import { datadogLogs } from '@datadog/browser-logs';

export function error(error?: any, message?: string, messageContext?: object) {
  datadogLogs.logger.error(
    message || 'Error occurred',
    messageContext || {},
    error,
  );
}

export function warn(error?: any, message?: string, messageContext?: object) {
  datadogLogs.logger.warn(message || 'Warning', messageContext || {}, error);
}

export function info(error?: any, message?: string, messageContext?: object) {
  datadogLogs.logger.info(message || 'Info', messageContext || {}, error);
}
